import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router';
import {DASHBOARD_PAGE, FAQ_PAGE, PROFILE_PAGE, WORKERS_PAGE} from '../../configuration/paths';
import TranslatedText from '../TranslatedText';


const MobileLocationIndicator = ({location}) => {
  const indicator = transKey => <h3 className="mobile-location-indicator"><TranslatedText transKey={transKey}/></h3>;

  switch (location.pathname) {
    case PROFILE_PAGE:
      return indicator('navigation.pages.profile');
    case WORKERS_PAGE:
      return indicator('navigation.pages.miners');
    case DASHBOARD_PAGE:
      return indicator('navigation.pages.dashboard');
    case FAQ_PAGE:
      return indicator('navigation.pages.faq');
    default:
      return null;
  }
};

MobileLocationIndicator.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

export default withRouter(connect()(React.memo(MobileLocationIndicator)));



// WEBPACK FOOTER //
// /src/components/navigation/MobileLocationIndicator.jsx